module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"2mynz","short_name":"2mynz","start_url":"/","background_color":"#E9540D","theme_color":"#E9540D","display":"minimal-ui","icon":"src/images/2mynz.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"72dac6ea17e276d2ff92117b01343f79"},
    }]
